// src/components/ImagineRow.js
import React from "react";
import "./ImagineRow.css";

const BASE = process.env.PUBLIC_URL || "landing-page";

export default function ImagineRow() {
  return (
    <section className="imagine-sec">
      <div className="imagine-sec__head">
        <h2 className="imagine-sec__title">...تخيّل</h2>
      </div>

      <div className="imagine-row">
        <article className="card card--high" aria-label="أخف داخليًا">
          <h3 className="card__title">أخف داخليًا</h3>
          <p className="card__text">
            ابدأ يومك براحة ووضوح، بعيد عن ثِقَل المبالغة.
          </p>
          <img
            className="arrow arrow--right"
            src={`${BASE}/assets/downArrow.png`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
          />
        </article>

        <article className="card card--low" aria-label="تنظيم ومشاعر">
          <h3 className="card__title">مشاعر و تنظيم</h3>
          <p className="card__text">
            أدوات يومية تساعدك تدير وقتك ومشاعرك ببساطة وبدون تعقيد.
          </p>
          <img
            className="arrow arrow--down"
            src={`${BASE}/assets/upArrow.png`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
          />
        </article>

        <article className="card card--high" aria-label="توازن عادة">
          <h3 className="card__title">توازن كعادة</h3>
          <p className="card__text">
            حول التوازن من مجرد حلم إلى ممارسة يومية ثابتة.
          </p>
          <img
            className="arrow arrow--left"
            src={`${BASE}/assets/downArrow.png`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
          />
        </article>

        <article className="card card--low" aria-label="مجتمع داعم">
          <h3 className="card__title">مجتمع داعم</h3>
          <p className="card__text">
            ناس يفهمونك بصدق، يشاركونك بشغفهم، ويقفون معك بلا أحكام.
          </p>
        </article>
      </div>
    </section>
  );
}
